import { NgModule } from '@angular/core';
import { PaginationComponent } from './pagination.component';
import { CommonModule } from '@angular/common';
import { FormBehaviorModule } from '@stratiods/form-behavior';
import { IconsModule } from '@stratiods/icons';

@NgModule({
  exports: [PaginationComponent],
  declarations: [PaginationComponent],
  imports: [
    CommonModule,
    FormBehaviorModule,
    IconsModule
  ]
})
export class PaginationModule {}
